<template>
  <div id="app">
    <div class="container">
      <Navbar/>
    </div>
    <hr class="hr"/>
    <br/>
    <div class="main-container">

      <NoForm v-if="!verifyingToken"/>

      <div v-if='verifyingToken'>

        <div class="text-center" v-if='loading'>
          <div class="spinner-border" role="status">
            <span class="sr-only">Cargando...</span>
          </div>
        </div>

        <div class="container" v-if="showModal">
          <div class="card-content">
            <div class="content">
              <h1 class="is-5 centered">
                {{ alert.title }}
              </h1>
              <p class="detail centered">
                {{ alert.detail }}
              </p>
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import Navbar from './components/Navbar.vue'
import NoForm from './components/NoForm.vue'
import axios from 'axios';

export default {
  name: 'app',
  components: {
    Navbar,
    NoForm,
  },
  mounted() {
    const userId = this.$route.query.userId
    const campaignId = this.$route.query.campaignId
    const donationId = this.$route.query.id
    if (!userId || !campaignId || !donationId) {
      this.verifyingToken = false
    } else {
      this.verifyingToken = true
      this.validateDonation(userId, campaignId, donationId)
    }
  },
  data() {
    return {
      verifyingToken: true,
      loading: true,
      showModal: false,
      alert: {
        title: '',
        detail: '',
      },
    }
  },
  methods: {
    validateDonation(userId, campaignId, donationId) {
      this.loading = true;
      axios.get(`${process.env.VUE_APP_SERVER_ENDPOINT}/donation/donate`, {
        params: {
          userId: userId,
          campaignId: campaignId,
          id: donationId,
        },
      }).then(() => {
        this.alert = {
          title: 'Muchas gracias por el aporte',
          detail: 'Su donación ha sido confirmada',
        }
        this.showModal = true;
      }).catch(err => {
        const code = err.response.status
        if (code === 403) {
          this.alert = {
            title: 'La donación ya ha sido validada',
            detail: 'Su donación ya ha sido validada'
          }
        } else {
          this.alert = {
            title: 'Ha ocurrido un error',
            detail: err.response.data
          }
        }
        this.showModal = true;
      }).finally(() => {
        this.loading = false;
      })
    },
  }
}
</script>

<style scoped>
.hr {
  background-color: #E6CE9E;
  margin: 0;
  height: 5px;
}
.centered {
  margin-top: 20px;
  text-align: center;
}
</style>
